<template>
  <div class="flex gap-3 flex-col md:flex-row u-row">
    <slot />
  </div>
</template>